const columns = (t) => [{
	caption: t('common.fields.time'),
	dataField: 'IntervalField'
}, {
	caption: t('common.strings.product'),
	dataField: 'Product'
}, {
	caption: t('common.strings.branch'),
	dataField: 'Shop'
}, {
	caption: t('common.fields.total_price'),
	dataField: 'Total',
	dataType: 'number',
	localFormat: { type: 'float' },
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	}
}, {
	caption: `${t('common.fields.total_price')}/${t('statistic_section.strings.customers')}`,
	dataField: 'PriceByOne',
	dataType: 'number',
	localFormat: { type: 'float' },
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	}
}, {
	caption: t('common.fields.quantity'),
	dataField: 'Amount',
	dataType: 'number',
	localFormat: { type: 'float' },
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	}
}, {
	caption: t('closing_section.fields.netto'),
	dataField: 'Netto',
	dataType: 'number',
	localFormat: { type: 'float' },
	groupSummary: {
		summaryType: 'sum',
		alignByColumn: true
	},
	summary: {
		summaryType: 'sum'
	}
}]

export default columns
